import {
  connect,
} from 'react-redux';
import {
  withRouter,
} from '@vroskus/library-navigation';
import {
  withTranslation,
} from 'react-i18next';

import {
  actions as mainActions,
} from '../../../redux/modules/main';
import {
  actions as authActions,
} from '../../../redux/modules/auth';

import LoginPageView from './LoginPageView';

// Types
import type {
  $State,
} from '../../../redux';
import type {
  $DispatchProps,
  $OwnProps,
  $StateProps,
} from './LoginPageView';

const mapStateToProps = ({
  auth,
}: $State): $StateProps => ({
  auth,
});

const mapDispatchToProps = (dispatchAction): $DispatchProps => ({
  authenticate: (params) => dispatchAction(
    authActions.authenticate(params),
  ),
  forgotPassword: (params) => dispatchAction(
    authActions.forgotPassword(params),
  ),
  redirect: (params) => dispatchAction(
    mainActions.redirect(params),
  ),
  resetPassword: (params) => dispatchAction(
    authActions.resetPassword(params),
  ),
  setupMainData: (params) => dispatchAction(
    mainActions.setupMainData(params),
  ),
  setupUser: (params) => dispatchAction(
    mainActions.setupUser(params),
  ),
});

const ConnectedComponent = connect<
$StateProps,
$DispatchProps,
$OwnProps,
$State
>(
  mapStateToProps,
  mapDispatchToProps,
)(LoginPageView);

const RoutedComponent = withRouter(ConnectedComponent);

const TranslatedComponent = withTranslation()(RoutedComponent);

const Component = TranslatedComponent;

export default Component;
